import api from "../../APIIntercepter";

async function assignClassScheduleAPI(params) {
  const url = `/classscheduleassign/admin`;
  const res = await api.post(url, params);
  return res.data;
}

async function assignClassScheduleByStudentAPI(studentId) {
  const url = `/classscheduleassign/admin/${studentId}`;
  const res = await api.get(url);
  return res.data;
}

async function deleteAssignClassScheduleAPI(id) {
  const url = `/classscheduleassign/admin?id=${id}`;
  const res = await api.delete(url);
  return res.data;
}

export {
  assignClassScheduleAPI,
  assignClassScheduleByStudentAPI,
  deleteAssignClassScheduleAPI,
};
